import { v5 as uuidV5 } from 'uuid';
const ANZ_NAMESPACE_ID = '3ecaf294-fb97-42ac-9154-43fa5a5d2151';
function getNamespacedId(name, group) {
    let namespace = ANZ_NAMESPACE_ID;
    if (group !== undefined) {
        namespace = uuidV5(group, namespace);
    }
    return uuidV5(name, namespace);
}
const WATCH_GROUP = 'watch';
const TUG_GROUP = 'tug';
const PILOT_GROUP = 'pilot';
const MOORING_GROUP = 'mooring';
const IN_PORT_GROUP = 'in-port';
const BUNKERING_GROUP = 'bunkering';
const AT_SEA_GROUP = 'at-sea';
const ANCHORING_GROUP = 'anchoring';
export const FIXED_PROTOCOL_TYPE_IDS = {
    WEATHER_OBSERVATION: getNamespacedId('EnvData'),
    ROUTE_MONITORING: getNamespacedId('RouteMonitoring'),
    NAVIGATION: getNamespacedId('NavData'),
    NAVIGATION_MANUAL_INPUT: getNamespacedId('NavManData'),
    GENERIC: getNamespacedId('GENERIC'),
    TIME_ZONE: getNamespacedId('time-zone'),
    SOUNDINGS: getNamespacedId('soundings'),
    FREE_ENTRY: getNamespacedId('free-entry'),
    TAKE_OVER_WATCH: getNamespacedId('take-over', WATCH_GROUP),
    HAND_OVER_WATCH: getNamespacedId('hand-over', WATCH_GROUP),
    TUG_ENGAGED: getNamespacedId('engaged', TUG_GROUP),
    TUG_RELEASED: getNamespacedId('released', TUG_GROUP),
    PILOT_ON_BOARD: getNamespacedId('on-board', PILOT_GROUP),
    PILOT_RELEASED: getNamespacedId('released', PILOT_GROUP),
    MOORING_ARRIVAL: getNamespacedId('arrival', MOORING_GROUP),
    MOORING_ARRIVAL_LINE_HANDLING: getNamespacedId('arrival-line-handling', MOORING_GROUP),
    MOORING_AFTER_ARRIVAL: getNamespacedId('after-arrival', MOORING_GROUP),
    MOORING_APPROACHING: getNamespacedId('approaching', MOORING_GROUP),
    MOORING_ARRIVAL_SWINGING: getNamespacedId('arrival-swinging', MOORING_GROUP),
    MOORING_ARRIVAL_CHECKLIST: getNamespacedId('arrival-checklist', MOORING_GROUP),
    MOORING_DEPARTURE: getNamespacedId('departure', MOORING_GROUP),
    MOORING_DEPARTURE_LINE_HANDLING: getNamespacedId('departure-line-handling', MOORING_GROUP),
    MOORING_BEFORE_DEPARTURE: getNamespacedId('before-departure', MOORING_GROUP),
    MOORING_SAILING_OFF: getNamespacedId('sailing-off', MOORING_GROUP),
    MOORING_DEPARTURE_SWINGING: getNamespacedId('departure-swinging', MOORING_GROUP),
    MOORING_DEPARTURE_CHECKLIST: getNamespacedId('departure-checklist', MOORING_GROUP),
    IN_PORT_STRESS_AND_STABILITY: getNamespacedId('stress-and-stability', IN_PORT_GROUP),
    IN_PORT_SAFETY_AND_SECURITY: getNamespacedId('safety-and-security', IN_PORT_GROUP),
    IN_PORT_PORT_OPERATIONS: getNamespacedId('port-operations', IN_PORT_GROUP),
    BUNKERING_STATION_ALONGSIDE: getNamespacedId('station-alongside', BUNKERING_GROUP),
    BUNKERING_STATION_OFF: getNamespacedId('station-off', BUNKERING_GROUP),
    AT_SEA_STRESS_AND_STABILITY: getNamespacedId('stress-and-stability', AT_SEA_GROUP),
    AT_SEA_SAFETY_AND_SECURITY: getNamespacedId('safety-and-security', AT_SEA_GROUP),
    AT_SEA_BNWAS: getNamespacedId('bnwas', AT_SEA_GROUP),
    AT_SEA_BEGIN_OR_END_OF_SEA_PASSAGE: getNamespacedId('begin-or-end-of-sea-passage', AT_SEA_GROUP),
    ANCHORING_SECURED: getNamespacedId('secured', ANCHORING_GROUP),
    ANCHORING_OUT_OF_THE_WATER: getNamespacedId('out-of-the-water', ANCHORING_GROUP),
    ANCHORING_AWEIGH: getNamespacedId('aweigh', ANCHORING_GROUP),
    ANCHORING_HEAVING_UP: getNamespacedId('heaving-up', ANCHORING_GROUP),
    ANCHORING_WATCH: getNamespacedId('watch', ANCHORING_GROUP),
    ANCHORING_VESSEL_AT_ANCHOR: getNamespacedId('vessel-at-anchor', ANCHORING_GROUP),
    ANCHORING_LET_GO: getNamespacedId('let-go', ANCHORING_GROUP),
    NOON_REPORT: getNamespacedId('noon-report'),
};
export const FIXED_PROTOCOL_CONTENT_TYPE_IDS = {
    WEATHER_OBSERVATION: getNamespacedId('weather-observation', FIXED_PROTOCOL_TYPE_IDS.WEATHER_OBSERVATION),
    ROUTE_MONITORING: getNamespacedId('route-monitoring', FIXED_PROTOCOL_TYPE_IDS.ROUTE_MONITORING),
    NAVIGATION: getNamespacedId('navigation', FIXED_PROTOCOL_TYPE_IDS.NAVIGATION),
    NAVIGATION_MANUAL_INPUT: getNamespacedId('navigation-manual-input', FIXED_PROTOCOL_TYPE_IDS.NAVIGATION_MANUAL_INPUT),
    GENERIC: getNamespacedId('generic', FIXED_PROTOCOL_TYPE_IDS.GENERIC),
    TIME_ZONE: getNamespacedId('time-zone', FIXED_PROTOCOL_TYPE_IDS.TIME_ZONE),
    SOUNDINGS: getNamespacedId('soundings', FIXED_PROTOCOL_TYPE_IDS.SOUNDINGS),
    FREE_ENTRY: getNamespacedId('free-entry', FIXED_PROTOCOL_TYPE_IDS.FREE_ENTRY),
    TAKE_OVER_WATCH: getNamespacedId('take-over', FIXED_PROTOCOL_TYPE_IDS.TAKE_OVER_WATCH),
    HAND_OVER_WATCH: getNamespacedId('hand-over', FIXED_PROTOCOL_TYPE_IDS.HAND_OVER_WATCH),
    TUG_ENGAGED: getNamespacedId('engaged', FIXED_PROTOCOL_TYPE_IDS.TUG_ENGAGED),
    TUG_RELEASED: getNamespacedId('released', FIXED_PROTOCOL_TYPE_IDS.TUG_RELEASED),
    PILOT_ON_BOARD: getNamespacedId('on-board', FIXED_PROTOCOL_TYPE_IDS.PILOT_ON_BOARD),
    PILOT_RELEASED: getNamespacedId('released', FIXED_PROTOCOL_TYPE_IDS.PILOT_RELEASED),
    MOORING_ARRIVAL: getNamespacedId('arrival', FIXED_PROTOCOL_TYPE_IDS.MOORING_ARRIVAL),
    MOORING_ARRIVAL_LINE_HANDLING: getNamespacedId('arrival-line-handling', FIXED_PROTOCOL_TYPE_IDS.MOORING_ARRIVAL_LINE_HANDLING),
    MOORING_AFTER_ARRIVAL: getNamespacedId('after-arrival', FIXED_PROTOCOL_TYPE_IDS.MOORING_AFTER_ARRIVAL),
    MOORING_PASSING_MARK: getNamespacedId('passing-mark', MOORING_GROUP),
    MOORING_SWINGING: getNamespacedId('swinging', MOORING_GROUP),
    MOORING_CHECKLIST: getNamespacedId('checklist', MOORING_GROUP),
    MOORING_DEPARTURE: getNamespacedId('departure', FIXED_PROTOCOL_TYPE_IDS.MOORING_DEPARTURE),
    MOORING_DEPARTURE_LINE_HANDLING: getNamespacedId('departure-line-handling', FIXED_PROTOCOL_TYPE_IDS.MOORING_DEPARTURE_LINE_HANDLING),
    MOORING_BEFORE_DEPARTURE: getNamespacedId('before-departure', FIXED_PROTOCOL_TYPE_IDS.MOORING_BEFORE_DEPARTURE),
    IN_PORT_STRESS_AND_STABILITY: getNamespacedId('stress-and-stability', FIXED_PROTOCOL_TYPE_IDS.IN_PORT_STRESS_AND_STABILITY),
    IN_PORT_SAFETY_AND_SECURITY: getNamespacedId('safety-and-security', FIXED_PROTOCOL_TYPE_IDS.IN_PORT_SAFETY_AND_SECURITY),
    IN_PORT_PORT_OPERATIONS: getNamespacedId('port-operations', FIXED_PROTOCOL_TYPE_IDS.IN_PORT_PORT_OPERATIONS),
    BUNKERING_STATION_ALONGSIDE: getNamespacedId('station-alongside', FIXED_PROTOCOL_TYPE_IDS.BUNKERING_STATION_ALONGSIDE),
    BUNKERING_STATION_OFF: getNamespacedId('station-off', FIXED_PROTOCOL_TYPE_IDS.BUNKERING_STATION_OFF),
    AT_SEA_STRESS_AND_STABILITY: getNamespacedId('stress-and-stability', FIXED_PROTOCOL_TYPE_IDS.AT_SEA_STRESS_AND_STABILITY),
    AT_SEA_SAFETY_AND_SECURITY: getNamespacedId('safety-and-security', FIXED_PROTOCOL_TYPE_IDS.AT_SEA_SAFETY_AND_SECURITY),
    AT_SEA_BNWAS: getNamespacedId('bnwas', FIXED_PROTOCOL_TYPE_IDS.AT_SEA_BNWAS),
    AT_SEA_BEGIN_OR_END_OF_SEA_PASSAGE: getNamespacedId('begin-or-end-of-sea-passage', FIXED_PROTOCOL_TYPE_IDS.AT_SEA_BEGIN_OR_END_OF_SEA_PASSAGE),
    ANCHORING_SECURED: getNamespacedId('secured', FIXED_PROTOCOL_TYPE_IDS.ANCHORING_SECURED),
    ANCHORING_OUT_OF_THE_WATER: getNamespacedId('out-of-the-water', FIXED_PROTOCOL_TYPE_IDS.ANCHORING_OUT_OF_THE_WATER),
    ANCHORING_AWEIGH: getNamespacedId('aweigh', FIXED_PROTOCOL_TYPE_IDS.ANCHORING_AWEIGH),
    ANCHORING_HEAVING_UP: getNamespacedId('heaving-up', FIXED_PROTOCOL_TYPE_IDS.ANCHORING_HEAVING_UP),
    ANCHORING_WATCH: getNamespacedId('watch', FIXED_PROTOCOL_TYPE_IDS.ANCHORING_WATCH),
    ANCHORING_VESSEL_AT_ANCHOR: getNamespacedId('vessel-at-anchor', FIXED_PROTOCOL_TYPE_IDS.ANCHORING_VESSEL_AT_ANCHOR),
    ANCHORING_LET_GO: getNamespacedId('let-go', FIXED_PROTOCOL_TYPE_IDS.ANCHORING_LET_GO),
    DECK_ENTRIES: getNamespacedId('deck-entries', FIXED_PROTOCOL_TYPE_IDS.NOON_REPORT),
    REMAINING_ON_BOARD: getNamespacedId('remaining-on-board', FIXED_PROTOCOL_TYPE_IDS.NOON_REPORT),
    CARGO_ENTRIES: getNamespacedId('cargo-entries', FIXED_PROTOCOL_TYPE_IDS.NOON_REPORT),
    REMARKS: getNamespacedId('remarks'),
    ENCRYPTED: getNamespacedId('encrypted'),
};
export const FIXED_BOOK_IDS = {
    BELL_BOOK: getNamespacedId('bellBook'),
    DECK_LOGBOOK: getNamespacedId('deckLogbook'),
};
//# sourceMappingURL=ProtocolTypeUtils.js.map